import { Component, TemplateRef, ViewChild } from '@angular/core';
import { User } from 'src/app/models/user';
import * as Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
import { first } from 'rxjs/operators';
import { LoginService } from 'src/app/services/login.service';
import { UserService } from 'src/app/services/user.service';
import moment from 'moment';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-recent-activities',
    templateUrl: './recent-activities.component.html',
    styleUrls: ['./recent-activities.component.css'],
    standalone: true,
    imports: [FormsModule, TranslateModule]
})
export class RecentActivitiesComponent {
  modalRef!: MatDialogRef<any>;
  @ViewChild('alerttemplate') alertTemplate!: TemplateRef<any>;
  msg: string = "";

  now = new Date();
  currentUser: User = new User;
  list: any;
  fromDate: any;
  toDate: any;
  recentActivities: any;
  finalList: any;
  dateNow: Date = new Date();
  dateFormat = 'YYYY-MM-DD HH:mm:ss';
  showContent = false;
  activeSection: 'activities' | 'versions' | null = null;
  showFilters: boolean = false;
  constructor(
    private userService: UserService,
    private loginService: LoginService,
    private dialog: MatDialog
  ) {
    this.loginService.currentUser.subscribe(x => this.currentUser = x);
    Exporting(Highcharts);
  }

  ngOnInit() {
    let now = new Date();
    let format = 'YYYY-MM-DD';
    let fdate = new Date(now.getTime() - 29 * 24 * 60 * 60 * 1000);
    this.fromDate = moment(fdate).format(format);
    this.toDate = moment(now).format(format);
    //this.toDate=moment(now).format(format);
    //this.fromDate=moment(now).subtract(7, 'days').startOf('day').format(format);


    this.getRecentActivities();

  }

  getRecentActivities() {


    this.userService.getRecentActivities(this.currentUser.email).pipe(first()).subscribe((response: any) => {

      this.list = response.data;


      this.doFilter();
    })
  }

  doFilter() {
    let from = new Date(this.fromDate).toISOString().replace('T', ' ').slice(0, 10) + ' 00:00:00';
    let to = new Date(this.toDate).toISOString().replace('T', ' ').slice(0, 10) + ' 23:59:59';


    if (this.fromDate && this.toDate && this.fromDate > this.toDate) {
      this.toDate = this.fromDate;
      this.msg = "Please Select a Valid Date";
      this.openAlertMod(this.alertTemplate, this.msg);
      // alert('Please Select a Valid Date');
    }

    this.recentActivities = this.list.filter((i: any) => i.aquireTime > from && i.aquireTime <= to);


    this.createActivityChart();
    this.createVersionChart();
  }
  toggleFilters() {
    this.showFilters = !this.showFilters;
  }

  dateFilter(diff: any) {
    // let now = new Date();
    let format = 'YYYY-MM-DD';
    // let fdate=new Date(now.getTime()-29*24*60*60*1000);
    // this.fromDate=moment(fdate).format(format);
    // this.toDate=moment(now).format(format);




    let prevDay = new Date(this.now.getTime() - (diff - 1) * 24 * 60 * 60 * 1000);


    //let prevDay=moment(now).subtract(7, 'days').startOf('day');
    let tDate = new Date(this.now.toISOString().slice(0, 16));
    let fDate = new Date(prevDay.toISOString().slice(0, 16));

    this.fromDate = moment(fDate).format(format)
    this.toDate = moment(tDate).format(format)



    this.doFilter();
    //   let prev7Day=new Date(now.getTime()-(d-1)*24*60*60*1000);
    // $scope.toDate=new Date(now.toISOString().slice(0, 16));
    // $scope.fromDate=new Date(prev7Day.toISOString().slice(0, 16));


  }

  toggleContent() {
    this.showContent = !this.showContent;
  }

  showActivities() {
    this.activeSection = 'activities';
  }

  showVersions() {
    this.activeSection = 'versions';
  }
  createActivityChart() {
    let parent = document.getElementById("activities");

    let opts: any = {
      chart: {
        renderTo: parent,
        height: 200,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie'
      },
      colors: ['#78d6d6', '#7cd12b'],
      legend: {
        align: 'right',
        verticalAlign: 'top',
        layout: 'vertical',
        x: 0,
        y: 50
      },
      credits: {
        enabled: false
      },
      title: {
        text: 'Activity Summary'
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      },
      accessibility: {
        enabled: false
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false
          },
          showInLegend: true
        }
      },
      series: [{
        name: 'Total',
        colorByPoint: true,
        data: [{
          name: 'Manual',
          y: this.recentActivities.filter((i: any) => i.Activity == 'Manual').length
        }, {
          name: 'Automation',
          y: this.recentActivities.filter((i: any) => i.Activity == 'Automation').length
        }]
      }]
    };
    new Highcharts.Chart(opts);
  }

  createVersionChart() {
    let data = this.formatVersionChartData();
    let parent = document.getElementById("versions");

    let opts: any = {
      chart: {
        renderTo: parent,
        height: 200,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie'
      },
      colors: ['#94c5ec', '#9dbfdd', '#558cb6', '#85a0b5', '#45667b', '#435761'],
      legend: {
        align: 'right',
        verticalAlign: 'top',
        layout: 'vertical',
        x: 0,
        y: 50
      },
      credits: {
        enabled: false
      },
      title: {
        text: 'Versions Summary'
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      },
      accessibility: {
        enabled: false
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false
          },
          showInLegend: true
        }
      },
      series: [{
        name: 'Total',
        colorByPoint: true,
        data: data
      }]
    };
    new Highcharts.Chart(opts);
  }

  // formatVersionChartData(){
  //   let i:any;
  //   let set=new Set(this.recentActivities.map((i)=>i.version));
  //   let data:any=[];
  //   set.forEach(i=>{
  //       let count=this.recentActivities.filter((j:any)=>j.version==i).length;
  //       let device=this.recentActivities.get()
  //       let temp={name: 'Android '+i, y: count }
  //       data.push(temp);
  //   })
  //   return data;
  // }
  formatVersionChartData() {
    let versionCounts = new Map<string, number>();

    this.recentActivities.forEach(activity => {
      let key = `${activity.platform} ${activity.version}`;
      versionCounts.set(key, (versionCounts.get(key) || 0) + 1);
    });

    let data = Array.from(versionCounts, ([name, count]) => ({ name, y: count }));

    return data;
  }

  openAlertMod(template: TemplateRef<any>, message: any) {
    this.modalRef = this.dialog.open(template, { width: '300px' });
    this.msg = message;
    setTimeout(() => {
      this.modalRef.close();
      this.msg = '';
    }, 2000)
  }

  Ok() {
    this.modalRef.close();
    this.msg = "";
  }
}
